import { Injectable } from '@angular/core';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AttributionTypeDTO, bankStatusEnum, ProfileDTO, statusEnum } from '../model/user-profiles-model';
import { UserProfilesServiceApi } from './user-profiles-api.service';

@Injectable()
export class UserProfilesStore {
  entry: any = {};

  constructor(private userProfileApi: UserProfilesServiceApi) {}

  private reloadProfiles = new BehaviorSubject<boolean>(false);
  public reloadProfiles$ = this.reloadProfiles.asObservable();

  public setReloadProfiles(value: boolean): void {
    this.reloadProfiles.next(value);
  }

  public getListAttributions(): Promise<AttributionTypeDTO[]> {
    return new Promise<AttributionTypeDTO[]>((resolve, reject) => {
      this.userProfileApi
        .getAtributionsProfile(this.entry)
        .toPromise()
        .then(
          (data) => {
            if (data) {
              data.sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
              resolve(data);
            } else reject(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  public updateAttribution(attribution: AttributionTypeDTO): Observable<any> {
    return this.userProfileApi.postUpdateAttributions(attribution);
  }

  public createProfile(profile: ProfileDTO): Observable<any> {
    return this.userProfileApi.postCreateProfile(profile);
  }

  public updateProfile(profile: ProfileDTO): Observable<any> {
    return this.userProfileApi.postUpdateProfile(profile);
  }

  public getProfiles(profile: ProfileDTO): Observable<ProfileDTO[]> {
    return this.userProfileApi.postGetProfiles(profile);
  }

  public getProfile(profile: ProfileDTO): Observable<ProfileDTO> {
    return this.userProfileApi.postGetProfile(profile);
  }

  public deleteProfile(profile: ProfileDTO): Observable<boolean> {
    return this.userProfileApi.postDeleteProfile(profile);
  }

  public getListProfiles(): Promise<ProfileDTO[]> {
    return new Promise<ProfileDTO[]>((resolve, reject) => {
      this.userProfileApi
        .postGetProfiles(this.entry)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }
}
